import React from 'react';
import { Phone, Mail, MapPin } from 'lucide-react';
import { Card, CardContent } from '../ui/card';

const ContactInfo = () => {
  return (
    <div className="lg:col-span-1 space-y-6">
      <Card className="border-2 border-emerald-200 bg-white">
        <CardContent className="p-8">
          <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mb-6">
            <Phone className="w-8 h-8 text-emerald-600" />
          </div>
          <h3 className="text-xl font-bold text-gray-900 mb-2">Phone</h3>
          <a href="tel:+919351292512" className="block text-lg text-emerald-600 hover:text-emerald-700" data-testid="contact-phone-primary">
            +91 93512 92512
          </a>
          <a href="tel:+919351002512" className="block text-lg text-emerald-600 hover:text-emerald-700" data-testid="contact-phone-secondary">
            +91 93510 02512
          </a>
          <p className="text-sm text-gray-600 mt-2">Mon-Sat: 9:00 AM - 6:00 PM</p>
        </CardContent>
      </Card>

      <Card className="border-2 border-emerald-200 bg-white">
        <CardContent className="p-8">
          <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mb-6">
            <Mail className="w-8 h-8 text-emerald-600" />
          </div>
          <h3 className="text-xl font-bold text-gray-900 mb-2">Email</h3>
          <a href="mailto:info@aldentechnologies.in" className="block text-lg text-emerald-600 hover:text-emerald-700 break-all" data-testid="contact-email-primary">
            info@aldentechnologies.in
          </a>
          <a href="mailto:aldentechnologiesindia@gmail.com" className="block text-sm text-gray-600 hover:text-emerald-700 break-all mt-1" data-testid="contact-email-alt">
            aldentechnologiesindia@gmail.com
          </a>
          <p className="text-sm text-gray-600 mt-2">24/7 Email Support</p>
        </CardContent>
      </Card>

      <Card className="border-2 border-emerald-200 bg-white">
        <CardContent className="p-8">
          <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mb-6">
            <MapPin className="w-8 h-8 text-emerald-600" />
          </div>
          <h3 className="text-xl font-bold text-gray-900 mb-2">Office Address</h3>
          <p className="text-gray-700 leading-relaxed">
            Kh No. 588, Loha Mandi Road<br />
            Macheda, Harmada<br />
            Jaipur - 302013
          </p>
        </CardContent>
      </Card>
    </div>
  );
};

export default ContactInfo;
